import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {PlayerAuthenticationService} from './player-authentication.service';
import {PLAYER_PREFIX_FULL} from '../player.routes';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardPlayerService
{
  private router = inject(Router);
  private playerAuthenticationService = inject(PlayerAuthenticationService);

  /**
   * Prüft, ob der Benuter angemeldet ist. Wird in routing-Datei als AuthGuard verwendet.
   */
  canActivate(route: ActivatedRouteSnapshot): boolean
  {
    if (!this.playerAuthenticationService.isAuthenticated())
    {
      console.log('[AuthGuardPlayerService] Nicht angemeldet');
      this.router.navigate([PLAYER_PREFIX_FULL + '/register']).then(() => {});
      return false;
    }
    return true;
  }
}
